import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import * as api from '../../api';
import { Btn, RNLLoader, Table } from '../UI';
import { fmtDate } from './mtoUtils';

// The take-offs sitting at a step the signed-in user can act on — straight from the approval engine's inbox.
export default function MTOApprovalQueue({ onOpen }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getMyInbox()
      .then(r => setItems((r || []).filter(i => i.entity_type === 'material_takeoff')))
      .catch(e => { setItems([]); setError(e.message || 'Could not load your approval queue.'); });
  }, []);

  const cols = [
    { key: 'ref', label: 'Ref', nowrap: true, render: (_, r) => <span style={{ fontFamily: 'monospace', fontWeight: 800, color: '#0b318b' }}>{r.context_data?.takeoff_ref || '—'}</span> },
    { key: 'rev', label: 'Rev', align: 'center', render: (_, r) => r.context_data?.revision || '—' },
    { key: 'step_name', label: 'Your Step', render: (v, r) => (
      <div>{v}{r.returned_from_step_name && <div style={{ fontSize: 10.5, color: '#9a3412' }}>sent back from {r.returned_from_step_name}</div>}</div>
    ) },
    { key: 'initiator_name', label: 'Submitted By' },
    { key: 'lines', label: 'Material Lines', align: 'right', render: (_, r) => r.context_data?.material_lines ?? '—' },
    { key: 'pending_since', label: 'Waiting Since', nowrap: true, render: fmtDate },
    { key: 'entity_id', label: 'Action', render: (id) => (
      <Btn style={{ padding: '5px 12px', fontSize: 12 }} onClick={() => onOpen(id)}><Eye size={13} /> Review</Btn>
    ) },
  ];

  return (
    <div>
      <h2 style={{ margin: 0, fontWeight: 700, fontSize: 20 }}>Approval Queue</h2>
      <p style={{ margin: '4px 0 16px', fontSize: 13, color: 'var(--text-secondary)' }}>
        Take-offs waiting at your approval step. Open one to approve it, return it to the engineer, or reject it.
      </p>
      {error && <div style={{ padding: '10px 14px', borderRadius: 10, background: '#fee2e2', color: '#991b1b', fontSize: 13, marginBottom: 12 }}>{error}</div>}
      {items === null ? <RNLLoader title="Loading queue..." subtitle="Checking your approval steps" /> : (
        <Table cols={cols} rows={items.map(i => ({ ...i, id: i.instance_id }))} emptyMsg="Nothing is waiting for your approval." />
      )}
    </div>
  );
}
